module.exports = __webpack_public_path__ + "static/medieval-technology-and-social-change-5cca5ba894b38e4fc8193df3654b5b29.jpg";